import React from 'react';

import FolderSelector from 'file-browser/FolderSelector';

interface FolderEditorProps {
  value: string | null;
  onChange: (folderId: string | null) => void;
  required: boolean;
  disabled?: boolean;
  showRegistries: boolean;
  showInventory?: boolean;
  showNotebook?: boolean;
}

export default function FolderEditor({
  value,
  onChange,
  required,
  disabled,
  showRegistries,
  showInventory = true,
  showNotebook = false,
}: FolderEditorProps): JSX.Element {
  return (
    <FolderSelector
      value={value}
      allowNone={!required}
      showRegistries={showRegistries}
      showInventory={showInventory}
      showNotebook={showNotebook}
      enableRedesign={true}
      level="append"
      error=""
      readOnly={Boolean(disabled)}
      requireSubfolderCreatableAuth={false}
      unsetOnFetchFail={false}
      checkExistingItemForDataModsMovement={false}
      noFolderText={required ? 'Choose folder' : 'Leave folder unchanged'}
      onChange={(e) => {
        // Normalize empty string to null (empty string is unset per RegistryUtil.parseFolderValue).
        onChange(e.target.value || null);
      }}
    />
  );
}
